<!-- 人员列表 -->
<template>
    <div class='page_content'>
        <setUserOrgAction ref="setUserOrgAction"></setUserOrgAction>
        <userAction ref="userAction"></userAction>
        <settingUserJurisdiction ref="settingUserJurisdiction"></settingUserJurisdiction>
        <!-- 穿梭框 -->
        <el-dialog :title="dotitle" :visible.sync="dialogtrasfertable" width="80%">
            <transfertable ref="transfertable" :unitExistVOList='unitExistVOList' :unitNoExistVOList="unitNoExistVOList" :tableLabel="tableLabel" :configleft="configleft" :configright="configright"
                           @changePage="getList()" @edit="editUser" @selection="addUser">
            </transfertable>
        </el-dialog>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" :buttonFlag="false"></v-button>
            <div class="page_content_top_line">
                <el-form :inline="true" :model="getRequestData" class="demo-form-inline" size="mini" label-width="100px">
                    <el-form-item label="名称">
                        <label slot="label" :style="$common.labelStyle('名称')" v-html="'名称'"></label>
                        <el-input class="form_codition" v-model.trim="getRequestData.opmName" placeholder="名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="部门">
                        <label slot="label" :style="$common.labelStyle('部门')" v-html="'部门'"></label>
                        <el-select v-model="getRequestData.depId" placeholder="请选择" clearable>
                            <el-option v-for="item in departmentList" :key="item.depId" :label="item.depName" :value="item.depId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                        <label slot="label" :style="$common.labelStyle('状态')" v-html="'状态'"></label>
                        <el-radio-group v-model="getRequestData.opmState" size="mini" @change="searchData">
                            <el-radio-button label="">全部</el-radio-button>
                            <el-radio-button :label="1">启用</el-radio-button>
                            <el-radio-button :label="0">停用</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="searchData">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="page_content_center">
            <el-table size="mini" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
                <el-table-column header-align='center' label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <el-table-column header-align='center' align="center" type="expand" label="身份" width="60">
                    <template slot-scope="props">
                        <el-tabs type="border-card">
                            <el-tab-pane label="人员身份">
                                <el-table size="mini" :data="[props.row]" border style="width: 100%">
                                    <el-table-column prop="opmAdmin" label="是否超管">
                                        <template slot-scope="subprops">
                                            <el-tag size="mini" v-if="subprops.row.opmAdmin == 0" type="danger">否
                                            </el-tag>
                                            <el-tag size="mini" v-if="subprops.row.opmAdmin == 1">是</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="opmAcceptor" label="是否验收人">
                                        <template slot-scope="subprops">
                                            <el-tag size="mini" v-if="subprops.row.opmAcceptor == 0" type="danger">否
                                            </el-tag>
                                            <el-tag size="mini" v-if="subprops.row.opmAcceptor == 1">是</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="opmBuyer" label="是否采购员">
                                        <template slot-scope="subprops">
                                            <el-tag size="mini" v-if="subprops.row.opmBuyer == 0" type="danger">否
                                            </el-tag>
                                            <el-tag size="mini" v-if="subprops.row.opmBuyer == 1">是</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="opmCashier" label="是否收款员">
                                        <template slot-scope="subprops">
                                            <el-tag size="mini" v-if="subprops.row.opmCashier == 0" type="danger">否
                                            </el-tag>
                                            <el-tag size="mini" v-if="subprops.row.opmCashier == 1">是</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="opmDistributor" label="是否配送员">
                                        <template slot-scope="subprops">
                                            <el-tag size="mini" v-if="subprops.row.opmDistributor == 0" type="danger">否
                                            </el-tag>
                                            <el-tag size="mini" v-if="subprops.row.opmDistributor == 1">是</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="opmDoctor" label="是否医师">
                                        <template slot-scope="subprops">
                                            <el-tag size="mini" v-if="subprops.row.opmDoctor == 0" type="danger">否
                                            </el-tag>
                                            <el-tag size="mini" v-if="subprops.row.opmDoctor == 1">是</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="opmDriver" label="是否司机">
                                        <template slot-scope="subprops">
                                            <el-tag size="mini" v-if="subprops.row.opmDriver == 0" type="danger">否
                                            </el-tag>
                                            <el-tag size="mini" v-if="subprops.row.opmDriver == 1">是</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="opmHeader" label="是否部门主管">
                                        <template slot-scope="subprops">
                                            <el-tag size="mini" v-if="subprops.row.opmHeader == 0" type="danger">否
                                            </el-tag>
                                            <el-tag size="mini" v-if="subprops.row.opmHeader == 1">是</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="opmKeeper" label="是否保管员">
                                        <template slot-scope="subprops">
                                            <el-tag size="mini" v-if="subprops.row.opmKeeper == 0" type="danger">否
                                            </el-tag>
                                            <el-tag size="mini" v-if="subprops.row.opmKeeper == 1">是</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="opmPharmacist" label="是否执业药师">
                                        <template slot-scope="subprops">
                                            <el-tag size="mini" v-if="subprops.row.opmPharmacist == 0" type="danger">否
                                            </el-tag>
                                            <el-tag size="mini" v-if="subprops.row.opmPharmacist == 1">是</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="opmReviewer" label="是否复核人">
                                        <template slot-scope="subprops">
                                            <el-tag size="mini" v-if="subprops.row.opmReviewer == 0" type="danger">否
                                            </el-tag>
                                            <el-tag size="mini" v-if="subprops.row.opmReviewer == 1">是</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="opmStore" label="是否修改单价">
                                        <template slot-scope="subprops">
                                            <el-tag size="mini" v-if="subprops.row.opmStore == 0" type="danger">否
                                            </el-tag>
                                            <el-tag size="mini" v-if="subprops.row.opmStore == 1">是</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="opmSalesperson" label="是否销售员">
                                        <template slot-scope="subprops">
                                            <el-tag size="mini" v-if="subprops.row.opmSalesperson == 0" type="danger">否
                                            </el-tag>
                                            <el-tag size="mini" v-if="subprops.row.opmSalesperson == 1">是</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="opmSpc" label="是否特药">
                                        <template slot-scope="subprops">
                                            <el-tag size="mini" v-if="subprops.row.opmSpc == 0" type="danger">否</el-tag>
                                            <el-tag size="mini" v-if="subprops.row.opmSpc == 1">是</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="opmPrice" label="是否价格特权">
                                        <template slot-scope="subprops">
                                            <el-tag size="mini" v-if="subprops.row.opmPrice == 0" type="danger">否
                                            </el-tag>
                                            <el-tag size="mini" v-if="subprops.row.opmPrice == 1">是</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="opmSitelogin" label="是否允许多设备登录">
                                        <template slot-scope="subprops">
                                            <el-tag size="mini" v-if="subprops.row.opmSitelogin == 0" type="danger">否
                                            </el-tag>
                                            <el-tag size="mini" v-if="subprops.row.opmSitelogin == 1">是</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="isPrint" label="是否打印">
                                        <template slot-scope="subprops">
                                            <el-tag size="mini" v-if="subprops.row.isPrint == 0" type="danger">否
                                            </el-tag>
                                            <el-tag size="mini" v-if="subprops.row.isPrint == 1">是</el-tag>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-tab-pane>
                        </el-tabs>
                    </template>
                </el-table-column>
                <el-table-column header-align='center' align="center" prop="opmCode" label="编码">
                </el-table-column>
                <el-table-column header-align='center' align="center" prop="depName" label="归属部门">
                </el-table-column>
                <el-table-column header-align='center' align="center" prop="opmJob" label="岗位">
                </el-table-column>
                <el-table-column header-align='center' align="center" prop="opmName" label="姓名">
                </el-table-column>

                <el-table-column header-align='center' align="center" prop="opmMne" label="助记码">
                </el-table-column>
                <el-table-column header-align='center' align="center" prop="opmAccount" label="登录账号">
                </el-table-column>
                <el-table-column header-align='center' align="center" prop="opmMobilenumber" label="手机号">
                </el-table-column>
                <el-table-column header-align='center' align="center" prop="opmTelenumber" label="固话">
                </el-table-column>
                <el-table-column header-align='center' align="center" prop="opmIdnumber" label="身份证号">
                </el-table-column>
                <el-table-column header-align='center' align="center" prop="opmSex" label="性别"></el-table-column>
                <el-table-column header-align='center' align="center" prop="jteId" label="模板编号"></el-table-column>
                <el-table-column header-align='center' align="center" prop="opmState" label="状态">
                    <template slot-scope="scope">
                        <el-tag size="mini">{{ scope.row.opmState == "0" ? "停用" : "启用" }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column header-align='center' align="center" prop="opmEmail" label="邮箱">
                </el-table-column>
                <el-table-column header-align='center' align="center" prop="banCi" label="班次">
                    <template slot-scope="scope">
                        <div v-if="scope.row.banCi">
                            {{ scope.row.banCi }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column header-align='center' align="center" prop="opmOnlinetime" label="在线时间">
                    <template slot-scope="scope">
                        <div v-if="scope.row.opmOnlinetime">
                            {{ $common.getLocalTime(scope.row.opmOnlinetime) }}
                        </div>
                    </template>
                </el-table-column>

            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

        </div>
        <el-dialog title="设置APP权限" :visible.sync="appDia" width="700px">
            <div>
                <el-tree :data="appList" ref="tree" show-checkbox node-key="id" @check="handleCheckChange" default-expand-all :default-checked-keys="selList" :props="defaultProps">
                </el-tree>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="appDia = false">取 消</el-button>
                <el-button type="primary" @click="confirmApp">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 不可见字段 -->
        <invisibleField ref="invisibleField"></invisibleField>
        <modulelist ref="modulelist"></modulelist>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import invisibleField from "@/components/invisibleField.vue";
import modulelist from "@/components/modulelist.vue";
import userAction from '@/components/userAction.vue'
import transfertable from '@/components/transfertable.vue'
import setUserOrgAction from '@/components/setUserOrgAction.vue'
import settingUserJurisdiction from '@/components/settingUserJurisdiction.vue'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: { invisibleField, modulelist, userAction, transfertable, setUserOrgAction, settingUserJurisdiction },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            selectedDataIndex: 0,
            buttonList: [],
            getRequestData: {
                opmName: "",
                depState: "",
                opgId: "",
                depId: "",
                page: 1,
                rows: 30,
                opmState: "",
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },

            departmentList: [],
            appDia: false,
            appList: [],
            defaultProps: {
                children: "children",
                label: "label",
            },
            selList: [],
            appOpmId: "",
            dialogtrasfertable: false,
            unitNoExistVOList: [],
            unitExistVOList: [],
            tableLabel1: [
                {
                    prop: "unitName",
                    label: "单位名称",
                    width: 100,
                },
                {
                    prop: "legalperson",
                    label: "法定代表人",
                    width: 100,
                },
                {
                    prop: "regaddres",
                    label: "注册地址",
                    width: 100,
                },
                // {
                //   prop: "socialcode",
                //   label: "统一社会信用代码",
                //   width: 100,
                // },
            ],
            tableLabel: [],
            bgmtableLabel: [
                {
                    prop: "bgmName",
                    label: "通用名称",
                    width: 100,
                },
                // {
                //   prop: "bgmId",
                //   label: "商品ID",
                //   width: 100,
                // },
            ],
            opmtableLabel: [
                {
                    prop: "opmName",
                    label: "业务员",
                    width: 100,
                },
                {
                    prop: "userName",
                    label: "货主业务员名称",
                    width: 100,
                },
            ],
            cotableLabel: [
                {
                    prop: "stName",
                    label: "库房名称",
                    width: 100,
                },
            ],
            cotableLabel1: [
                {
                    prop: "coName",
                    label: "货主名称",
                    width: 100,
                },
            ],
            transfertype: 0,
            unitType: 0,
            configleft: {
                page: 1,
                rows: 30,
                total: 0,
                loading: false,
                name: "",
            },
            configright: {
                page: 1,
                rows: 30,
                total: 0,
                loading: false,
                name: "",
            },
            dotitle: "",
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        handleCheckChange(currentObj, treeStatus) {
            console.log(currentObj, treeStatus)
            console.log(this.$refs.tree.getCheckedNodes());
        },
        // 绑定商品
        chuansuo(unitType) {
            this.dialogtrasfertable = true;
            this.getList();
            this.unitType = unitType;
        },
        // 绑定
        async getList() {
            console.log(this.configleft, this.configright);
            // 供货商客户
            if (this.transfertype == 8) {
                this.tableLabel = this.tableLabel1;
                let asright = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    unitType: 0,
                    page: this.configright.page,
                    rows: 30,
                    unitName: this.configright.name,
                };
                let asleft = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    unitType: this.unitType,
                    page: this.configleft.page,
                    rows: 30,
                    unitName: this.configleft.name,
                };
                let datae = await this.$http.userUnitqueryUserNoExistUnit(asleft);
                let responseData = await this.$http.userUnitqueryUserExistUnit(asright);
                if (responseData.status == 200) {
                    this.unitExistVOList = responseData.result.list;
                    this.configright.total = responseData.result.total;
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
                if (datae.status == 200) {
                    this.unitNoExistVOList = datae.result.list;
                    this.configleft.total = datae.result.total;
                } else {
                    this.$message({
                        message: datae.message,
                        type: "error",
                    });
                }
                // 商品
            } else if (this.transfertype == 9) {
                this.tableLabel = this.tableLabel1;
                let asright = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    unitType: 1,
                    page: this.configright.page,
                    rows: 30,
                    unitName: this.configright.name,
                };
                let asleft = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    unitType: this.unitType,
                    page: this.configleft.page,
                    rows: 30,
                    unitName: this.configleft.name,
                };
                let datae = await this.$http.userUnitqueryUserNoExistUnit(asleft);
                let responseData = await this.$http.userUnitqueryUserExistUnit(asright);
                if (responseData.status == 200) {
                    this.unitExistVOList = responseData.result.list;
                    this.configright.total = responseData.result.total;
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
                if (datae.status == 200) {
                    this.unitNoExistVOList = datae.result.list;
                    this.configleft.total = datae.result.total;
                } else {
                    this.$message({
                        message: datae.message,
                        type: "error",
                    });
                }
            } else if (this.transfertype == 10) {
                this.tableLabel = this.bgmtableLabel;
                let asright = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    unitType: this.unitType,
                    page: this.configright.page,
                    rows: 30,
                    bgmName: this.configright.name,
                };
                let asleft = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    unitType: this.unitType,
                    page: this.configleft.page,
                    rows: 30,
                    bgmName: this.configleft.name,
                };
                let responseData = await this.$http.userGoodsqueryUserNoExistGoods(
                    asleft
                );
                let datae = await this.$http.userGoodsqueryUserExistGoods(asright);
                if (datae.status == 200) {
                    this.unitExistVOList = datae.result.list;
                    this.configright.total = datae.result.total;
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
                if (responseData.status == 200) {
                    this.unitNoExistVOList = responseData.result.list;
                    this.configleft.total = responseData.result.total;
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            } else if (this.transfertype == 11) {
                this.tableLabel = this.opmtableLabel;
                let asright = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    unitType: this.unitType,
                    page: this.configright.page,
                    rows: 30,
                    opmName: this.configright.name,
                };
                let asleft = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    unitType: this.unitType,
                    page: this.configleft.page,
                    rows: 30,
                    opmName: this.configleft.name,
                };
                let responseData = await this.$http.couserqueryNoUser(asleft);
                let datae = await this.$http.couserqueryUser(asright);
                if (datae.status == 200) {
                    console.log(datae);
                    this.unitExistVOList = datae.result.list;
                    this.configright.total = datae.result.total;
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
                if (responseData.status == 200) {
                    this.unitNoExistVOList = responseData.result.list;
                    this.configleft.total = responseData.result.total;
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            } else if (this.transfertype == 12) {
                this.tableLabel = this.cotableLabel;
                let asright = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    unitType: this.unitType,
                    page: this.configright.page,
                    rows: 30,
                    stName: this.configright.name,
                };
                let asleft = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    unitType: this.unitType,
                    page: this.configleft.page,
                    rows: 30,
                    stName: this.configleft.name,
                };
                let responseData = await this.$http.userStqueryUserNoExistSt(asleft);
                let datae = await this.$http.userStqueryUserExistSt(asright);
                if (datae.status == 200) {
                    this.unitExistVOList = datae.result.list;
                    this.configright.total = datae.result.total;
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
                if (responseData.status == 200) {
                    this.unitNoExistVOList = responseData.result.list;
                    this.configleft.total = responseData.result.total;
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            } else if (this.transfertype == 17) {
                this.tableLabel = this.cotableLabel1;
                let asright = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    unitType: this.unitType,
                    page: this.configright.page,
                    rows: 10,
                    coName: this.configright.name,
                };
                let asleft = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    unitType: this.unitType,
                    page: this.configleft.page,
                    rows: 10,
                    coName: this.configleft.name,
                };
                let responseData = await this.$http.userCargoownerqueryNoCoId(asleft);
                let datae = await this.$http.userCargoownerqueryCoId(asright);
                if (datae.status == 200) {
                    this.unitExistVOList = datae.result.list;
                    this.configright.total = datae.result.total;
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
                if (responseData.status == 200) {
                    this.unitNoExistVOList = responseData.result.list;
                    this.configleft.total = responseData.result.total;
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            }
        },
        // 选取
        async addUser(unitIdList) {
            console.log(unitIdList, "----");
            // 供货商客户

            if (this.transfertype == 8) {
                let aslist = [];
                unitIdList.forEach((item) => {
                    aslist.push(item.unitId);
                });
                let as = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    operateType: 0,
                    unitIdList: aslist,
                    unitType: 0,
                };
                let responseData = await this.$http.userUnitsetUserUnitData(as);
                if (responseData.status == 200) {
                    this.$message.success(responseData.message);
                    this.getList();
                } else {
                    this.$message.error(responseData.message);
                }
            } else if (this.transfertype == 9) {
                let aslist = [];
                unitIdList.forEach((item) => {
                    aslist.push(item.unitId);
                });
                let as = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    operateType: 0,
                    unitIdList: aslist,
                    unitType: 1,
                };
                let responseData = await this.$http.userUnitsetUserUnitData(as);
                if (responseData.status == 200) {
                    this.$message.success(responseData.message);
                    this.getList();
                } else {
                    this.$message.error(responseData.message);
                }
            } else if (this.transfertype == 10) {
                let aslist = [];
                unitIdList.forEach((item) => {
                    aslist.push(item.bgmId);
                });
                let as = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    operateType: 0,
                    goodsList: aslist,
                };
                let responseData = await this.$http.userGoodssetUserGoodsData(as);
                if (responseData.status == 200) {
                    this.$message.success(responseData.message);
                    this.getList();
                } else {
                    this.$message.error(responseData.message);
                }
            } else if (this.transfertype == 11) {
                let aslist = [];
                unitIdList.forEach((item) => {
                    aslist.push(item.opmId);
                });
                let as = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    operateType: 0,
                    unitIdList: aslist,
                };
                let responseData = await this.$http.couseradd(as);
                if (responseData.status == 200) {
                    this.$message.success(responseData.message);
                    this.getList();
                } else {
                    this.$message.error(responseData.message);
                }
            } else if (this.transfertype == 12) {
                let aslist = [];
                unitIdList.forEach((item) => {
                    aslist.push(item.stId);
                });
                //   商品
                let as = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    operateType: 0,
                    stIds: aslist,
                };
                let responseData = await this.$http.userStadd(as);
                if (responseData.status == 200) {
                    this.$message.success(responseData.message);
                    this.getList();
                } else {
                    this.$message.error(responseData.message);
                }
            } else if (this.transfertype == 17) {
                let aslist = [];
                unitIdList.forEach((item) => {
                    aslist.push(item.coId);
                });
                //   商品
                let as = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    operateType: 0,
                    unitIdList: aslist,
                };
                let responseData = await this.$http.userCargoowneradd(as);
                if (responseData.status == 200) {
                    this.$message.success(responseData.message);
                    this.getList();
                } else {
                    this.$message.error(responseData.message);
                }
            }
        },
        // 取消
        async editUser(unitIdList) {
            if (this.transfertype == 8) {
                let aslist = [];
                unitIdList.forEach((item) => {
                    aslist.push(item.unitId);
                });
                let as = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    operateType: 1,
                    unitIdList: aslist,
                    unitType: 0,
                };
                let responseData = await this.$http.userUnitsetUserUnitData(as);
                if (responseData.status == 200) {
                    this.$message.success(responseData.message);
                    this.getList();
                } else {
                    this.$message.error(responseData.message);
                }
            } else if (this.transfertype == 9) {
                let aslist = [];
                unitIdList.forEach((item) => {
                    aslist.push(item.unitId);
                });
                //   商品
                let as = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    operateType: 1,
                    unitIdList: aslist,
                    unitType: 1,
                };
                let responseData = await this.$http.userUnitsetUserUnitData(as);
                if (responseData.status == 200) {
                    this.$message.success(responseData.message);
                    this.getList();
                } else {
                    this.$message.error(responseData.message);
                }
            } else if (this.transfertype == 10) {
                let aslist = [];
                unitIdList.forEach((item) => {
                    aslist.push(item.bgmId);
                });
                //   商品
                let as = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    operateType: 1,
                    goodsList: aslist,
                };
                let responseData = await this.$http.userGoodssetUserGoodsData(as);
                if (responseData.status == 200) {
                    this.$message.success(responseData.message);
                    this.getList();
                } else {
                    this.$message.error(responseData.message);
                }
            } else if (this.transfertype == 11) {
                let aslist = [];
                unitIdList.forEach((item) => {
                    aslist.push(item.opmId);
                });
                let as = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    operateType: 1,
                    unitIdList: aslist,
                };
                let responseData = await this.$http.couseradd(as);
                if (responseData.status == 200) {
                    this.$message.success(responseData.message);
                    this.getList();
                } else {
                    this.$message.error(responseData.message);
                }
            } else if (this.transfertype == 12) {
                let aslist = [];
                unitIdList.forEach((item) => {
                    aslist.push(item.stId);
                });
                //   商品
                let as = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    operateType: 1,
                    stIds: aslist,
                };
                let responseData = await this.$http.userStadd(as);
                if (responseData.status == 200) {
                    this.$message.success(responseData.message);
                    this.getList();
                } else {
                    this.$message.error(responseData.message);
                }
            } else if (this.transfertype == 17) {
                let aslist = [];
                unitIdList.forEach((item) => {
                    aslist.push(item.coId);
                });
                //   商品
                let as = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    operateType: 1,
                    unitIdList: aslist,
                };
                let responseData = await this.$http.userCargoowneradd(as);
                if (responseData.status == 200) {
                    this.$message.success(responseData.message);
                    this.getList();
                } else {
                    this.$message.error(responseData.message);
                }
            }
        },
        // 动作集合
        actionSet(actionData) {
            console.log(actionData)
            this.dotitle = actionData.jurName;
            this.transfertype = actionData.actionType;
            switch (actionData.actionType) {
                case 0:
                    this.$refs["userAction"].openBox(
                        actionData.actionType,
                        this.departmentList,
                        ""
                    );
                    break;
                case 1:
                    if (this.returnData.list <= 0) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    }
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    if (!dataInfo) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.$refs["userAction"].openBox(
                        actionData.actionType,
                        this.departmentList,
                        dataInfo
                    );
                    break;
                case 2:
                    this.delDataAction();
                    break;
                case 3:
                    this.setDataAction();
                    break;
                case 4:
                    this.openUserJurisdiction();
                    break;
                case 5:
                    this.settingOrder();
                    break;
                case 6:
                    if (this.returnData.list <= 0) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    }
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    if (!dataInfo) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.settingAppJurisdiction();
                    break;
                case 8:
                    if (this.returnData.list <= 0) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    } else {
                        if (this.returnData.list[this.selectedDataIndex].opmType == 1) {
                            var dataInfo = this.returnData.list[this.selectedDataIndex];
                            if (!dataInfo) {
                                this.$message({
                                    message: "请先选中要操作的数据",
                                    type: "error",
                                });
                                return false;
                            }
                            this.chuansuo(0);
                        } else {
                            this.$message.error("货主用户才能绑定！");
                        }
                    }

                    break;
                case 9:
                    if (this.returnData.list <= 0) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    } else {
                        if (this.returnData.list[this.selectedDataIndex].opmType == 1) {
                            var dataInfo = this.returnData.list[this.selectedDataIndex];
                            if (!dataInfo) {
                                this.$message({
                                    message: "请先选中要操作的数据",
                                    type: "error",
                                });
                                return false;
                            }
                            this.chuansuo(1);
                        } else {
                            this.$message.error("货主用户才能绑定！");
                        }
                    }

                    break;
                case 10:
                    if (this.returnData.list <= 0) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    } else {
                        if (this.returnData.list[this.selectedDataIndex].opmType == 1) {
                            var dataInfo = this.returnData.list[this.selectedDataIndex];
                            if (!dataInfo) {
                                this.$message({
                                    message: "请先选中要操作的数据",
                                    type: "error",
                                });
                                return false;
                            }
                            this.chuansuo(1);
                        } else {
                            this.$message.error("货主用户才能绑定！");
                        }
                    }
                    break;
                case 11:
                    if (this.returnData.list <= 0) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    } else {
                        if (this.returnData.list[this.selectedDataIndex].opmType == 1) {
                            var dataInfo = this.returnData.list[this.selectedDataIndex];
                            if (!dataInfo) {
                                this.$message({
                                    message: "请先选中要操作的数据",
                                    type: "error",
                                });
                                return false;
                            }
                            this.chuansuo(1);
                        } else {
                            this.$message.error("货主用户才能绑定！");
                        }
                    }
                    break;
                case 12:
                    if (this.returnData.list <= 0) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    } else {
                        var dataInfo = this.returnData.list[this.selectedDataIndex];
                        if (!dataInfo) {
                            this.$message({
                                message: "请先选中要操作的数据",
                                type: "error",
                            });
                            return false;
                        }
                        this.chuansuo(1);
                    }
                    break;
                case 13:
                    this.openInvi()
                    break;
                case 14:
                    this.resetPass();
                    break;
                case 15:
                    if (this.returnData.list <= 0) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    }
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    if (!dataInfo) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.$refs.modulelist.openBox(dataInfo)
                    break;
                case 16://清除用户权限
                    if (this.returnData.list <= 0) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    }

                    this.clearUser()
                    break;
                case 17://清除用户权限
                    if (this.returnData.list <= 0) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    } else {
                        // if (this.returnData.list[this.selectedDataIndex].opmType == 1) {
                            var dataInfo = this.returnData.list[this.selectedDataIndex];
                            if (!dataInfo) {
                                this.$message({
                                    message: "请先选中要操作的数据",
                                    type: "error",
                                });
                                return false;
                            }
                            this.chuansuo(1);
                        // } else {
                        //     this.$message.error("货主用户才能绑定！");
                        // }
                    }
                    break;
            }
        },
        clearUser() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.$confirm("此操作将清除该人员绑定的所有权限，是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.opmId],
                    };
                    let responseData = await this.$http.JurisdictionCleanOperJur(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "操作成功!",
                        });
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => {
                })
        },
        // 重置密码
        resetPass() {
            if (this.returnData.list <= 0) {
                this.$message({
                    message: "暂无数据",
                    type: "error",
                });
                return false;
            }
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.$confirm("此操作将重置密码，是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.opmId],
                    };
                    let responseData = await this.$http.resetPassword(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "操作成功!",
                        });
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => {
                })
        },
        // 设置不可见字段
        openInvi() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.$refs.invisibleField.openDia(dataInfo.opmId)
        },
        async settingAppJurisdiction() {
            let responseData = await this.$http.getAllAppJurisdiction();
            if (responseData.status == 200) {
                this.handleJurisdiction(responseData.result);
                this.appList = this.handleJurisdiction(responseData.result);
                this.appDia = true;
                this.getOneAppJurisdiction();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async getOneAppJurisdiction() {
            this.selList = [];
            this.appOpmId = this.returnData.list[this.selectedDataIndex].opmId;
            let sendDataInfo = {
                ids: [this.appOpmId],
            };
            let responseData = await this.$http.getOneAppJurisdiction(sendDataInfo);
            if (responseData.status == 200) {
                var arr = this.handleJurisdiction(responseData.result);
                var arrIds = []
                arr.forEach(item1 => {
                    this.appList.forEach(item => {
                        if (item.children.length != item1.children.length && item.mpJurId == item1.mpJurId) {
                            arrIds.push(item.mpJurId)
                        }
                    })
                })
                responseData.result.forEach((item, i) => {
                    this.selList.push(Number(item.mpJurId));
                });
                arrIds.forEach(item => {
                    this.selList.forEach((val, key) => {
                        if (val == item) {
                            this.selList.splice(key, 1)
                        }
                    })
                })
                console.log(this.selList);
                this.selList = JSON.parse(JSON.stringify(this.selList));
                this.$refs.tree.setChecked(this.selList, true);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async confirmApp() {
            var keyList = this.$refs.tree.getCheckedKeys();
            var nodeList = this.$refs.tree.getCheckedNodes();
            this.appList.forEach(item => {
                nodeList.forEach(item1 => {
                    if (item.mpJurId == item1.mpJurParentid) {
                        keyList.push(item.mpJurId)
                    }
                })
            })
            var arr = Array.from(new Set(keyList))
            let sendDataInfo = {
                mpJurId: arr,
                opmId: this.appOpmId,
            };
            let responseData = await this.$http.saveAppJurisdiction(sendDataInfo);
            if (responseData.status == 200) {
                this.$message({
                    type: "success",
                    message: "保存成功",
                });
                this.appDia = false;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 权限处理
        handleJurisdiction(data, id = 0, lev = 0) {
            var son = [];
            data.forEach((value, keys) => {
                value["selectedStatus"] = false;
                if (value["mpJurParentid"] == id) {
                    value["id"] = value["mpJurId"];
                    value["value"] = value["mpJurId"];
                    value["label"] = value["mpJurName"];
                    var list = this.handleJurisdiction(data, value["mpJurId"], lev + 1);
                    value["children"] = this.handleJurisdiction(
                        data,
                        value["mpJurId"],
                        lev + 1
                    );
                    son.push(value);
                }
            });
            return son;
        },
        openUserJurisdiction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }

            this.$refs["settingUserJurisdiction"].openBox(dataInfo);
        },
        // 设置人员组织
        async settingOrder() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.$refs["setUserOrgAction"].openBox(dataInfo);
        },
        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
// 修改状态
        async setDataAction() {
            if (this.returnData.list <= 0) {
                this.$message({
                    message: "暂无数据",
                    type: "error",
                });
                return false;
            }
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            var sendData = {
                ids: [dataInfo.opmId],
            };
            let responseData = await this.$http.setUserStatus(sendData);
            if (responseData.status == 200) {
                this.$message({
                    type: "success",
                    message: "操作成功!",
                });
                this.getDataList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },

        // 删除数据
        delDataAction() {
            if (this.returnData.list <= 0) {
                this.$message({
                    message: "暂无数据",
                    type: "error",
                });
                return false;
            }
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.opmId],
                    };
                    let responseData = await this.$http.delUser(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });
                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                })
                .catch(() => { });
        },

        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.getUserList(this.getRequestData);
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
                this.selectedDataIndex = 0;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取全部部门
        async getAllDepartmentList() {
            let requestData = await this.$http.getAllDepartmentList();
            if (requestData.status == 200) {
                this.departmentList = requestData.result;
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getDataList();
        this.getButtonList();
        this.getAllDepartmentList();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>